import { render, staticRenderFns } from "./regular-filter-selector-rounded.component.vue?vue&type=template&id=42721f8e"
import script from "./regular-filter-selector-rounded.component.vue?vue&type=script&lang=ts"
export * from "./regular-filter-selector-rounded.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports